import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useGetApiNews } from '../../api/news.api';
import { News } from '../../models/news.model';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './page-search.css';
import CircularLoading from '../../shared/CircularLoading/CircularLoading';
import { NewsResponseViewModel, postApiNews } from '../../api';
import Header from '../../components/Header/Header';

const SearchPage = () => {
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const query = searchParams.get('query') || '';

	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [dataNewsList, setDataNews] = useState<NewsResponseViewModel[]>([]);

	const obtenerNoticia = async () => {
		setIsLoading(true);
		setError(null);
		try {
			const response = await postApiNews({
				page: 1,
				size: 100,
			});
			setDataNews([...(response.results ?? [])]);
		} catch (err) {
			setError(err instanceof Error ? err.message : 'An error occurred while fetching news');
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		obtenerNoticia();
	}, [query]);

	// Filtrar las noticias por el término de búsqueda
	const filteredNews = query
		? dataNewsList?.filter((news) => news.title?.toLowerCase().includes(query.toLowerCase())) || []
		: dataNewsList || []; // Si no hay query, mostrar todas las noticias

	// Obtener la cantidad de resultados
	const resultCount = filteredNews.length;

	// Redirigir al hacer clic en una noticia
	const handleClick = (id: any) => {
		// setSearchTerm(""); // Limpiar el input
		navigate(`/noticia/${id}`); // Redirige a la página de la noticia
	};
	// Si la API está cargando o hubo un error, mostrar mensajes apropiados
	if (isLoading)
		return (
			<div className="results_row results_row-loading">
				<CircularLoading />{' '}
			</div>
		);
	if (error)
		return (
			<div className="results_row results_row-error">
				<p>{error}</p>
			</div>
		);

	return (
		<>
			<Header>
				<h2 className="results_title">{t('pageresults.title')}</h2>
			</Header>

			<div className="results_row">
				{resultCount > 0 ? (
					<p className="results_cant">
						{resultCount} {t('pageresults.results')} <b>{query}</b>
					</p>
				) : (
					<p className="results_cant">
						{t('pageresults.no_results')} <b>{query}</b>
					</p>
				)}

				{resultCount > 0 && (
					<div className="results_container">
						{filteredNews.map((news: any) => (
							<div
								className="results_item"
								key={news.id}
								onClick={() => handleClick(news.id)}>
								<div className="results_figure">
									<img
										src={news.image}
										alt={news.title}
									/>
								</div>
								<div className="results_data">
									<h3 className="results_item_title">{news.title}</h3>
									<p className="results_item_text">{news.summary}</p>
								</div>
							</div>
						))}
					</div>
				)}
			</div>
		</>
	);
};

export default SearchPage;
